import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'si-info-dialog',
  templateUrl: './info-dialog.component.html',
  styleUrls: ['./info-dialog.component.scss']
})
export class InfoDialogComponent {
  @Input() displayDialog: boolean;
  @Input() dialogTitle: string;
  @Input() dialogText: string;
  @Output() displayDialogChange = new EventEmitter<boolean>();

  onVisibleChange(value: boolean): void {
    this.displayDialogChange.emit(value);
  }
}
